module.exports = __webpack_public_path__ + "img/rollout-icon-dark.a98c287d.svg";